import App from './app.js';
App.install();
